import TestimonialCard from '@/components/common/CourseDescriptionPage/AlumniTestimonialTextType/TestimonialCard';
import SectionTitle from '@/components/common/SectionTitle';
// import VideoModal from '@/components/common/VideoModal';
import CategoryPageContext from '@/context/CategoryPageContext';
import { Container, Slider } from '@pwskills/rachnaui';
import React, { useContext } from 'react';
import VideoComponent from '../VideoContainer';

const Testimonial = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const testimonial = categoryDetails?.testimonial;

  return (
    <Container className="py-8 medium:pt-14 medium:pb-[52px] medium:!px-8 large:!px-20 flex flex-col ">
      <div>
        <SectionTitle lowerText="Alumni Testimonials" upperText="Transformed Lives" />
      </div>

      <div className="flex flex-col medium:!flex-row medium:!items-center medium:!justify-start  gap-x-[17px] relative gap-y-6 mt-[50px]">
        <div
          className="w-full medium:!w-[700px] relative medium:!-top-9 !medium:h-[202px] !large:h-[248px]"
          aria-hidden="true"
        >
          {testimonial?.videoUrl ? (
            <VideoComponent url={testimonial?.videoUrl} />
          ) : (
            testimonial?.image && (
              <img
                src={testimonial?.image as string}
                alt={(testimonial?.altText as string) || 'testimonial-image'}
                width={410}
                height={248}
                className="!w-full !h-full "
              />
            )
          )}
        </div>

        <Slider
          className="flex gap-4 mb-5  w-full"
          wrapperClass="gap-2 flex flex-col  medium:w-full medium:items-start medium:justify-start "
          iconWrapperClass="w-full !p-0 self-end !mx-0 flex justify-center  medium:!justify-end"
          positionOfSliderInMobile="bottom"
        >
          {testimonial &&
            testimonial?.testimonials?.map((testimonialData, index) => (
              <TestimonialCard
                key={testimonialData._id}
                index={index}
                testimonialImage={testimonialData?.testimonialImage || ''}
                description={testimonialData?.description}
                designation={testimonialData.designation}
                name={testimonialData?.name}
              />
            ))}
        </Slider>
      </div>
    </Container>
  );
};

export default Testimonial;
